module.exports = __webpack_public_path__ + "files/416b2668df62de7e2e3f2cd94fc676d5.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/travel_places-5.png
// module id = 518
// module chunks = 76